<template>
  <div class="card shadow-lg" :class="cardClass">
    <header v-if="icon || label"
            class="card-header d-flex justify-content-between align-content-center text-uppercase bg-light"
            :class="icon || label ? 'p-2' : 'p-0'"
            @click="collapse">
            <span class="my-auto" v-if="icon || label">
                <fa-icon v-if="icon" :icon="icon"></fa-icon>
                <strong class="ml-1">{{ label }}</strong>
            </span>
      <span>
        <slot name="header"></slot>
        <fa-icon v-if="collapsable && collapsed" :icon="['fal', 'chevron-circle-down']" class="ml-1" />
        <fa-icon v-if="collapsable && !collapsed" :icon="['fal', 'chevron-circle-up']" class="ml-1" />
      </span>
    </header>
    <transition name="accordion">
      <main class="card-body p-0 position-relative" v-show="!collapsed" :class="collapsable ? 'collapsable' : ''">
        <span v-if="secure" class="secure-icon"><fa-icon :icon="['fas', 'lock']" /></span>
        <slot></slot>
      </main>
    </transition>
    <footer>
      <slot name="footer" class="card-footer"></slot>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'BSCard',
  props: ['icon', 'label', 'secure', 'collapsable'],
  data () {
    return {
      collapsed: false
    }
  },
  mounted () {
    if (this.collapsable) this.collapsed = true
  },
  computed: {
    cardClass () {
      let returnClass = ''
      if (this.secure) { returnClass += ' card-secure' }
      if (this.collapsable) { returnClass += ' clickable' }
      return returnClass
    }
  },
  methods: {
    collapse () {
      if (this.collapsable) {
        this.collapsed = !this.collapsed
      }
    }
  }
}
</script>

<style lang="scss">
.card-header {
  font-size: 0.875rem;
}

.card-body {
  &.collapsable {
    height: 400px;
    overflow: hidden;
  }
  .secure-icon {
    svg {
      font-size: 7rem;
      position: absolute;
      bottom: 0;
      left: -30px;
      opacity: 0.2;
    }

    ~ * {
      position: relative;
      z-index: 1;
    }
  }
}

.accordion-enter-active, .accordion-leave-active {
  transition: height .25s ease-in;
}
.accordion-enter, .accordion-leave-to {
  height: 0!important;
}

</style>
